import { Allergen } from "../store/articles/models/Allergen";

export const allergens = {
  1: new Allergen(1, "", "Gluten"),
  2: new Allergen(2, "", "Schaaldieren"),
  3: new Allergen(3, "", "Eieren"),
  4: new Allergen(4, "", "Vis"),
  5: new Allergen(5, "", "Pinda"),
  6: new Allergen(6, "", "Soja"),
  7: new Allergen(7, "", "Melk"),
  8: new Allergen(8, "", "Noten"),
  9: new Allergen(9, "", "Selderij"),
  10: new Allergen(10, "", "Mosterd"),
  11: new Allergen(11, "", "Sesamzaad"),
  12: new Allergen(12, "", "Zwaveldioxide en Sulfiet"),
  13: new Allergen(13, "", "Lupine"),
  14: new Allergen(14, "", "Weekdieren"),
  15: new Allergen(15, "", "Lactose"),
};
